import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/injectable/auth/auth.service";
import { Token } from "src/app/model/token";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "../app.component";
import { DialogComponent } from "../../shared/components/dialog/dialog.component";
import { UserService } from "src/app/injectable/user.service";
import { User } from "src/app/model/user";
import { TranslateService } from "@ngx-translate/core";
import { Sender } from "src/app/model/sender";
import { MatDialog } from "@angular/material/dialog";
import { BadCredentialsComponent } from "../bad-credentials/bad-credentials.component";
import { VERSION } from "src/environments/version";
import { Store } from "@ngxs/store";
import { SetCategories, SetUser } from "src/app/app-state";
import { AdminService } from "src/app/injectable/admin.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  version = VERSION.version;
  visible: boolean;
  user: string;
  userName: string;
  password: string;
  spinner = false;
  serverMessage: any = "";

  constructor(
    public authService: AuthService,
    public userService: UserService,
    private adminService: AdminService,
    private router: Router,
    private route: ActivatedRoute,
    public app: AppComponent,
    public dialog: MatDialog,
    private translate: TranslateService,
    private store: Store
  ) {}

  ngOnInit() {
    this.userService.resetRouteBlock = false;
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("");
  }

  login() {
    this.spinner = true;
    this.authService.post(this.user, this.password).subscribe(
      (token: Token) => {
        sessionStorage.setItem("token", token.access_token);
        this.userService.user().subscribe((user: User) => {
          this.store.dispatch(new SetUser(user));
          sessionStorage.setItem("user", user.username);
          sessionStorage.setItem("userID", user.id.toString());
          sessionStorage.setItem("lang", user.lang.toLowerCase());
          this.translate.setDefaultLang(user.lang.toLowerCase());
          this.app.user = sessionStorage.getItem("user");
          sessionStorage.setItem("DataOld", this.password);
          if (user.passwordReset === false) {
            this.router.navigate([""]);
          } else {
            sessionStorage.setItem("needPasswordReset", "true");
            this.router.navigate(["change-password"]);
          }
          if (user.roles.find((item) => item.name == "ROLE_ADMIN")) {
            this.getAllCategories();
            this.router.navigate(["/clients"], { relativeTo: this.route });
          } else {
            this.router.navigate(["/messages"], { relativeTo: this.route });
          }
        });
      },
      () => {
        this.spinner = false;
        this.serverMessage = "LOG01";
        this.openDialog();
      }
    );
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(BadCredentialsComponent);
    dialogRef.afterClosed().subscribe((result) => {});
  }

  getAllCategories() {
    this.adminService.getAllCategories().subscribe((value) => {
      this.store.dispatch(new SetCategories(value));
    });
  }
}
